@if (indexNarrative.content !== null && indexNarrative.loadingStatus === RequestStatus.loaded) {
  <div class="mc-index-info-popover info-popover">
    @if (showScrollToTop) {
      <button
        type="button"
        class="mc-scroll-to-top btn btn-compact mc-btn-primary"
        (click)="scrollToTopClicked()"
        data-testid="btn-back-to-top"
      >
        <i class="fa fa-chevron-up"></i> Back to top
      </button>
    }
    <div class="modal-container">
      <div #popoverContainer (scroll)="onScroll($event)" class="modal-body mc-index-info-popover-content-container">
        <div class="modal-body-header">
          <button
            type="button"
            id="dismissButton"
            class="IndexInfoPopover__close"
            (click)="activeModal.dismiss('Cross click')"
            aria-label="Dismiss"
            data-hook="ask-an-analyst-dismiss-btn"
            ngbTooltip="Close window"
            xauto-index-info-modal-close
            data-testid="btn-close-popup"
          >
            <grid-ui-icon class="close-icon" name="cross"></grid-ui-icon>
          </button>
        </div>

        <div class="mc-index-info-popover-header d-flex justify-content-between">
          <input ngbAutofocus class="no-size" tabindex="-1" />
          <h2 class="mc-index-name">{{ indexNarrative.content!.name }}</h2>
        </div>

        @let sections = indexNarrative.content?.content?.sections;

        @if (sections) {
          @let definition = sections.definition;
          @let methodology = sections.methodology;
          @let sources = sections.sources;

          @if (definition && methodology && sources) {
            <div class="mc-index-info-popover-links-bar">
              <div class="mc-flex-wrapper">
                @if (dowloadingPdf()) {
                  <div class="me-auto d-flex align-items-center">
                    <div class="mc-pdf-image-container">
                      <span class="processing-pdf" data-hook="mc-report-dropdown-processing-pdf">
                        <svg viewBox="0 0 512 512">
                          <path
                            fill="black"
                            d="M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"
                          ></path>
                        </svg>
                      </span>
                      <span class="pdf-text fadeInMove">Processing PDF</span>
                    </div>
                  </div>
                } @else {
                  <button
                    type="button"
                    class="IndexInfoPopover__pdf-button mc-link mc-pdf-link me-auto d-flex align-items-center"
                    (click)="downloadPdf(indexNarrative.content!)"
                    data-testid="btn-download-pdf"
                  >
                    <div class="mc-pdf-image-container">
                      <img class="mc-pdf-image" src="assets/img/icons/pdf-white.svg" />
                    </div>
                    <span>PDF</span>
                  </button>
                }

                @for (anchorLink of anchorLinks; track $index) {
                  <a
                    class="mc-link mc-anchor-link"
                    tabindex="0"
                    (click)="scrollToAnchor($index)"
                    (keydown.enter)="scrollToAnchor($index)"
                    [attr.data-testid]="'link-' + anchorLink | slugify"
                  >
                    <grid-ui-icon class="icon-next" name="arrow-curve-right"></grid-ui-icon>
                    <span>{{ anchorLink }}</span>
                  </a>
                }
              </div>
            </div>
          }

          <div #sectionsContainer (scroll)="onScroll($event)" class="mc-index-info-popover-content">
            <div class="mc-section">
              <h3 class="mc-section-title">Definition</h3>
              <div [style.display]="definition.definition_of_index.length === 0 ? 'none' : 'block'" class="grid-ui-body-item-container">
                <h4 class="grid-ui-body-item-heading h-sup">Definition of the Index</h4>
              </div>
              <div class="grid-ui-body-item-container">
                @for (bodyItem of definition.definition_of_index; track bodyItem; let index = $index) {
                  <grid-ui-body-item
                    [bodyItem]="bodyItem"
                    [previousBodyItem]="index > 0 ? definition.definition_of_index[index - 1] : undefined"
                    [enableNestedBodyItem]="true"
                    (writtenContentLinkActionEmit)="handleWrittenContentLinkAction($event)"
                  >
                  </grid-ui-body-item>
                }
                <div [style.display]="definition.definition_of_issue.length === 0 ? 'none' : 'block'" class="grid-ui-body-item-container">
                  <h4 class="grid-ui-body-item-heading h-sup">Definition of the Issue</h4>
                </div>
                @for (bodyItem of definition.definition_of_issue; track bodyItem; let index = $index) {
                  <grid-ui-body-item
                    [bodyItem]="bodyItem"
                    [previousBodyItem]="index > 0 ? definition.definition_of_issue[index - 1] : undefined"
                    [enableNestedBodyItem]="true"
                    (writtenContentLinkActionEmit)="handleWrittenContentLinkAction($event)"
                  >
                  </grid-ui-body-item>
                }
                <div
                  [style.display]="definition.characteristics_of_index.length === 0 ? 'none' : 'block'"
                  class="grid-ui-body-item-container"
                >
                  <h4 class="grid-ui-body-item-heading h-sup">Characteristics of the Index</h4>
                </div>
                @for (bodyItem of definition.characteristics_of_index; track bodyItem; let index = $index) {
                  <grid-ui-body-item
                    [bodyItem]="bodyItem"
                    [previousBodyItem]="index > 0 ? definition.characteristics_of_index[index - 1] : undefined"
                    [enableNestedBodyItem]="true"
                    (writtenContentLinkActionEmit)="handleWrittenContentLinkAction($event)"
                  >
                  </grid-ui-body-item>
                }
              </div>
              <hr class="mc-section-divider" />
            </div>

            @if (methodology) {
              <div class="mc-section">
                <h3 class="mc-section-title">Methodology</h3>
                <div [style.display]="methodology.objective.length === 0 ? 'none' : 'block'" class="grid-ui-body-item-container">
                  <h4 class="grid-ui-body-item-heading h-sup">Objective</h4>
                </div>
                <div class="grid-ui-body-item-container">
                  @for (bodyItem of methodology.objective; track bodyItem; let index = $index) {
                    <grid-ui-body-item
                      [bodyItem]="bodyItem"
                      [previousBodyItem]="index > 0 ? methodology.objective[index - 1] : undefined"
                      [enableNestedBodyItem]="true"
                      (writtenContentLinkActionEmit)="handleWrittenContentLinkAction($event)"
                    >
                    </grid-ui-body-item>
                  }
                </div>
                <div [style.display]="methodology.construction.length === 0 ? 'none' : 'block'" class="grid-ui-body-item-container">
                  <h4 class="grid-ui-body-item-heading h-sup">Construction</h4>
                </div>
                <div class="grid-ui-body-item-container">
                  @for (bodyItem of methodology.construction; track bodyItem; let index = $index) {
                    <grid-ui-body-item
                      [bodyItem]="bodyItem"
                      [previousBodyItem]="index > 0 ? methodology.construction[index - 1] : undefined"
                      [enableNestedBodyItem]="true"
                      (writtenContentLinkActionEmit)="handleWrittenContentLinkAction($event)"
                    >
                    </grid-ui-body-item>
                  }
                </div>
                <div [style.display]="methodology.limitations.length === 0 ? 'none' : 'block'" class="grid-ui-body-item-container">
                  <h4 class="grid-ui-body-item-heading h-sup">Limitations</h4>
                </div>
                <div class="grid-ui-body-item-container">
                  @for (bodyItem of methodology.limitations; track bodyItem; let index = $index) {
                    <grid-ui-body-item
                      [bodyItem]="bodyItem"
                      [previousBodyItem]="index > 0 ? methodology.limitations[index - 1] : undefined"
                      [enableNestedBodyItem]="true"
                      (writtenContentLinkActionEmit)="handleWrittenContentLinkAction($event)"
                    >
                    </grid-ui-body-item>
                  }
                </div>
                <div [style.display]="methodology.research.length === 0 ? 'none' : 'block'" class="grid-ui-body-item-container">
                  <h4 class="grid-ui-body-item-heading h-sup">Research</h4>
                </div>
                <div class="grid-ui-body-item-container">
                  @for (bodyItem of methodology.research; track bodyItem; let index = $index) {
                    <grid-ui-body-item
                      [bodyItem]="bodyItem"
                      [previousBodyItem]="index > 0 ? methodology.research[index - 1] : undefined"
                      [enableNestedBodyItem]="true"
                      (writtenContentLinkActionEmit)="handleWrittenContentLinkAction($event)"
                    >
                    </grid-ui-body-item>
                  }
                </div>
                <hr class="mc-section-divider" />
              </div>
            }

            @if (sources) {
              <div class="mc-section">
                <h3 class="mc-section-title">Sources</h3>
                <div class="grid-ui-body-item-container">
                  @for (bodyItem of sources; track bodyItem; let index = $index) {
                    <grid-ui-body-item
                      [bodyItem]="bodyItem"
                      [previousBodyItem]="index > 0 ? sources[index - 1] : undefined"
                      [enableNestedBodyItem]="true"
                      (writtenContentLinkActionEmit)="handleWrittenContentLinkAction($event)"
                    >
                    </grid-ui-body-item>
                  }
                </div>
              </div>
            }
          </div>
        } @else {
          <p class="mc-index-info-popover-no-content">No content is available</p>
        }
      </div>
    </div>
  </div>
}

@if (indexNarrative.loadingStatus === RequestStatus.loading) {
  <div class="mc-index-info-popover loading-container">
    <div class="mc-index-info-popover-content-container">
      <div class="mc-index-info-popover-content-loader">
        <grid-ui-loading [message]="'Loading, please wait..'"></grid-ui-loading>
      </div>
    </div>
  </div>
}

@if (indexNarrative.loadingStatus === RequestStatus.error && indexNarrative.error !== null) {
  <div class="mc-index-info-popover error-container">
    <div class="mc-index-info-popover-content-container">
      <div class="mc-index-info-popover-header mc-index-info-popover-margin">
        <button
          type="button"
          id="dismissButton"
          class="mc-dismiss-icon btn-close"
          aria-label="Dismiss"
          xauto-index-info-modal-close
          (click)="activeModal.dismiss('Cross click')"
        >
          <svg class="icon small">
            <use xlink:href="#shape-close" />
          </svg>
        </button>
      </div>
      <grid-ui-error
        [errorCode]="indexNarrative.error!.errorCode"
        [errorMessage]="indexNarrative.error!.errorMessage"
        [errorPrimaryAction]="indexNarrative.error!.errorPrimaryAction"
        [showContact]="indexNarrative.error!.showContact"
        [contactEmail]="indexNarrative.error!.contactEmail"
        (primaryActionClick)="retryDataLoad()"
      >
      </grid-ui-error>
    </div>
  </div>
}
